// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__iLbEY","label":"Radio_label__35jQS","checkMark":"Radio_checkMark__2RyzQ","disabled":"Radio_disabled__2jRJq"};